
import {
  TBaseTypographyProps,
  TTypographyAlign,
  TTypographyAlignSubsetProp,
  TTypographyColor,
  TTypographyTag,
  TTypographyWhitespace,
  BASE_TYPOGRAPHY_DEFAULTS,
} from "@/ui/components/typography/typography.config";
import { DefinedDefaults, SubsetKeys, subsetOf } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_TEXT_HERO_TAGS = subsetOf<TTypographyTag>()([ "h1", "h2", "div" ]);

export const AVAILABLE_TEXT_HERO_COLORS =
  subsetOf<TTypographyColor>()([ "default" ]);

export const AVAILABLE_TEXT_HERO_ALIGNMENTS =
  subsetOf<TTypographyAlign>()([ "left", "center" ]);

export const AVAILABLE_TEXT_HERO_WHITESPACE =
  subsetOf<TTypographyWhitespace>()([ "normal", "balance" ]);

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TTextHeroColor = SubsetKeys<typeof AVAILABLE_TEXT_HERO_COLORS>;
export type TTextHeroTag = SubsetKeys<typeof AVAILABLE_TEXT_HERO_TAGS>;
export type TTextHeroAlign = SubsetKeys<typeof AVAILABLE_TEXT_HERO_ALIGNMENTS>;
export type TTextHeroWhitespace = SubsetKeys<typeof AVAILABLE_TEXT_HERO_WHITESPACE>;

export type TTextHeroProps = TBaseTypographyProps & {
  color?: TTextHeroColor;
  align?: TTypographyAlignSubsetProp<TTextHeroAlign>;
  tag?: TTextHeroTag;
  whitespace?: TTextHeroWhitespace;
};

type TTextHeroDefaultProps = DefinedDefaults<
  TTextHeroProps,
  "color" | "align" | "tag" | "whitespace"
>;

/*-------------------------------------
  |  Defaults
  |-------------------------------------*/

export const TEXT_HERO_DEFAULTS = {
  ...BASE_TYPOGRAPHY_DEFAULTS,
  color: "default",
  align: "left",
  tag: "h1",
  whitespace: "normal",
} satisfies TTextHeroDefaultProps;
